import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { OpenAnswer } from '@shared/models/question-types/open-answer';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { QuestionBaseComponent } from '../question-base/question-base.component';
import { OpenAnswerInputComponent } from './open-answer-input/open-answer-input.component';

@Component({
  selector: 'app-open-answer',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    OpenAnswerInputComponent,
    QuestionBaseComponent,
    SafeHtmlPipe,
],
  templateUrl: './open-answer.component.html',
  styleUrl: './open-answer.component.scss',
})
export class OpenAnswerComponent {
  @Input({ required: true }) control!: any;
  @Input({ required: true }) question!: OpenAnswer;
  @Input() inMatrix: boolean = false;
  @Input() isFirstQuestion: boolean = false;
}
